import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {BrowserRouter} from "react-router-dom";

import * as firebase from "firebase/app";

// Firebase
const firebaseConfig = {
    apiKey: "AIzaSyD3XSnWP5MM_f5StkrnbKwKVU-OwM0nlrM",
    authDomain: "magicfeedback-website.firebaseapp.com",
    projectId: "magicfeedback-website",
    storageBucket: "magicfeedback-website.appspot.com",
    messagingSenderId: "902703320413",
    appId: "1:902703320413:web:43654b17cb7042b7aaecb4",
};

firebase.initializeApp(firebaseConfig);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <BrowserRouter>
        <App/>
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
